import React from "react";

function ReloadButton() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <button
      style={{
        padding: "0.5rem 1rem",
        backgroundColor: "#00274C",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
      }}
      onClick={handleReload}
    >
      New Game
    </button>
  );
}

export default ReloadButton;
